import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class SearchViolationNoticesResultDto {
    violationId: number;
    violationNoticeId: number;
    combinedOwner: string;
    accountNumber: string;
    community: string;
    communityId: number;
    propertyAddress: string;
    category: string;
    subCategory: string;
    location: string;
    status: string;
    violationNoticeType: string;
    violationStatus: string;
    noticeUrl: string;

    @Type(() => Date)
    inspectDate: Date;

    inspectStatus: string;

    @Type(() => UserNameDisplayResultDto)
    inspector: UserNameDisplayResultDto;

    regarding: string;
    preFineOverride: string;
    reviewRequest: string;

    @Type(() => Date)
    reviewDate: Date;

    closedReason: string;
    @Type(() => UserNameDisplayResultDto)
    closedBy: UserNameDisplayResultDto;

    // Transient variable
    showRegarding = false;

    get closedByDisplayText(): string {
        return Utils.notNullAndDefined(this.closedBy) ? this.closedBy.displayName : '';
    }

    get inspectorDisplayText(): string {
        return Utils.notNullAndDefined(this.inspector) ? this.inspector.displayName : '';
    }
}
